import { FC, memo } from 'react'
import { Center } from '@chakra-ui/react'

import { GoToAuthenticationButton, CustomFeedback } from 'components'
import { useAuthentication } from 'contexts/Authentication/Provider'

type Props = {
  children: JSX.Element
}

const MustBeLoggedIn: FC<Props> = ({ children }) => {
  const { user } = useAuthentication()

  if (user !== null) return children

  return (
    <Center height="100vh">
      <CustomFeedback context="notLoggedIn">
        <GoToAuthenticationButton size="lg" />
      </CustomFeedback>
    </Center>
  )
}

export default memo(MustBeLoggedIn)
